import { render, staticRenderFns } from "./Landing2Vision.vue?vue&type=template&id=1d024fd1&scoped=true"
import script from "./Landing2Vision.vue?vue&type=script&lang=js"
export * from "./Landing2Vision.vue?vue&type=script&lang=js"
import style0 from "./Landing2Vision.vue?vue&type=style&index=0&id=1d024fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d024fd1",
  null
  
)

export default component.exports